import React from 'react';
import WeatherCenter from 'components/Weather/WeatherCenter';

const WeatherPage = () => {
  return <WeatherCenter />;
};

export default WeatherPage;
